// Meta-list's place in the navigation stack. It opens as a 'meta-list' crumb
// whose context is { type: 'metaType', value: <dimension> }, and every filter
// applied while on it appends another 'meta-list' crumb (BD-1112). So neither
// the pivot nor the page it was opened from is simply the last entry.

// Index of the first crumb in the trailing run of meta-list crumbs.
export function metaListRunStart(stack) {
    let start = stack.length;
    while (start > 0 && stack[start - 1].id === 'meta-list') start -= 1;
    return start;
}

// The crumb carrying the pivot dimension, and the crumb meta-list was opened from.
export function metaListContext(stack) {
    const start = metaListRunStart(stack);
    const pivot = stack.slice(start).reverse().find((e) => e.context?.type === 'metaType') || null;
    return { pivot, origin: start > 0 ? stack[start - 1] : null };
}
